import React from 'react';
import axios from 'helpers/axios';

import { Container, Title, Label, TextInput, Button, Form, Image } from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { useToasts, useUser, useLayout } from 'hooks';

export const ForgotPassword = () => {
  const [state, setState] = React.useState({ email: '' });
  const { setLayoutLoading } = useLayout();
  const { errorToast, successToast } = useToasts();
  const { redirectTo } = useUser();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLayoutLoading(true);
      const response = await axios.post('/auth/forgot', {
        username: state.email,
      });
      if (response.status === 200) {
        successToast('A password reset link was sent to your email address.', {
          autoDismissTimeout: 10000,
        });
        redirectTo('/sign-in');
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Please retry later.' });
    }
    setLayoutLoading(false);
  };

  return (
    <AuthLayout justifyContent="start">
      <Container width="80%" maxWidth="480px" height="auto" top="15%">
        <Container alignItems="center" mb="l">
          <Image alt="mailbox" src="/assets/img/mailbox.png" />
        </Container>
        <Title mb="m">Forgot password?</Title>
        <Title type="h3" variant="grey" mb="m">
          Please enter your email address
        </Title>
        <Form onSubmit={handleSubmit}>
          <Container mb="xs">
            <Label htmlFor="email" mb="xs">
              Email
            </Label>
            <TextInput
              id="email"
              name="email"
              type="email"
              placeholder="Email"
              value={state.email}
              onChange={handleChange}
              required
              autoFocus
            />
          </Container>
          <Button type="submit" my="m">
            Forgot password
          </Button>
        </Form>
      </Container>
    </AuthLayout>
  );
};
